<dx-check-box [(value)]="value" (onValueChanged)="onValueChanged()"
  [text]="label"></dx-check-box>